import React from "react";
import InfoCard from "components/InfoCard";
import { useSelector } from "react-redux";
import { selectDictionaries } from "slices/dictionary/selectors";

const DictionaryInfo = () => {
  const dictionaries = useSelector(selectDictionaries);
  const inUse = dictionaries.filter(
    (dictionary) =>
      dictionary.usedBy.folders.length > 0 ||
      dictionary.usedBy.documents.length > 0
  );
  const uniqueAuthors = new Set(
    dictionaries
      .filter((dictionary) => dictionary.createdBy !== null)
      .map((dictionary) => dictionary.createdBy)
  );

  return (
    <div className="dictionary__info">
      <header>Workspace Dictionary Stats</header>
      <InfoCard
        left={<span>{dictionaries.length}</span>}
        right={<span>Total number of dictionaries</span>}
      />
      <InfoCard
        left={<span>{inUse.length}</span>}
        right={<span>Total in use dictionaries</span>}
      />
      <InfoCard
        left={<span>{dictionaries.length - inUse.length}</span>}
        right={<span>Total dictionaries not in use</span>}
      />
      <InfoCard
        left={<span>{uniqueAuthors.size}</span>}
        right={<span>Users who created dictionaries</span>}
      />
    </div>
  );
};

export default DictionaryInfo;
